import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Icon from 'img/burger.svg';

class TopbarSidebarButton extends PureComponent {
  static propTypes = {
    changeMobileSidebarVisibility: PropTypes.func.isRequired,
    changeSidebarVisibility: PropTypes.func.isRequired,
  };

  render() {
    const {
      changeMobileSidebarVisibility,
      changeSidebarVisibility,
    } = this.props;

    return (
      <div>
        <button
          type="button"
          className="topbar-button topbar-button-desktop"
          onClick={changeSidebarVisibility}
        >
          <img src={Icon} alt="" className="topbar-button-icon" />
        </button>
        <button
          type="button"
          className="topbar-button topbar-button-mobile"
          onClick={changeMobileSidebarVisibility}
        >
          <img src={Icon} alt="" className="topbar-button-icon" />
        </button>
      </div>
    );
  }
}

export default TopbarSidebarButton;
